// Wait for element to exist.
function elementLoaded(el, cb) {
  if ($(el).length) {
    cb($(el));
  } else {
    setTimeout(function () {
      elementLoaded(el, cb)
    }, .1);
  }
};

window.code = Math.floor(Math.random() * 10000000) + 1;
elementLoaded('#email_signup', function (el) {
  $('input[id=k_id]').val(window.code);
});

$(document).on('click','#k_id_submit',function(){
  //window.code = Math.floor(Math.random() * 10000000) + 1;
  $(this).css("background", "#454545");
  $('input[id=k_id]').val(window.code);
});

$('.klaviyo-form button:contains("COPY")').click(function( event ) {
  $(this).css("background", "#1f8ec9");
  copyToClipboard('.klaviyo-form a');
});

if($(window).width() > 911){
 $('.klaviyo-form button:contains("SHARE")').hide();
}

$('.klaviyo-form button:contains("SHARE")').click(function(event) {
  event.preventDefault();
  console.log("share clicked");
  if (navigator.share) {
    navigator.share({
        title: 'WIN x2 $1000 Travel Vouchers',
        text: 'Check this out! If you purchase through this link we both go in the draw to win x2 $1000 travel vouchers. Imagine where we could go',
        url: 'https://snapwireless.com.au/pages/win-x2-1000-travel-vouchers?utm_source=referral&utm_medium='+window.name+'-'+window.code+'&utm_campaign=voucher',
      })
      .then(() => console.log('Successful share'))
      .catch((error) => console.log('Error sharing', error));
  } else {
    console.log('Share not supported on this browser, do it the old way.');
  }
});

function copyToClipboard(element) {
  //preventDefault();
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val($(element).text()).select();
  document.execCommand("copy");
  $temp.remove();
}